import React from "react";
import {withEuroOrDash} from "../../../utils/utils";
import {getClearingAccountName} from './utils'

const RowNumberCell = {
  header: 'Nr.',
  body: {
    content: (item, options, index) => `${index + 1}.`,
  },
  key: 'RowNumberCell'
}

const NameCell = {
  header: 'Konto',
  body: {
    content: (item) => getClearingAccountName(item),
    className: 'name bold',
    ellipsis: true
  },
  key: 'NameCell'
}

const ValueCell = {
  header: 'Saldo',
  body: {
    content: (item) => withEuroOrDash(item.ctx_currency_value),
  },
  key: 'ValueCell'
}

const tableStructure = {
  default: [
    {
      content: [RowNumberCell],
    },
    {
      content: [NameCell]
    },
    {
      content: [ValueCell],
      align: 'right'
    }
  ]
}

export default tableStructure;